/* eslint-disable @typescript-eslint/no-unused-vars */
import * as Match2 from '..';
import createActions from '../../config/actions/createActions';
import { action } from '@play-co/replicant';

/** Development mode only, not allowed in production  */
export const match2DailyChallengeCheats = createActions({
  /**
   * Reset current daily challenges and clear all pending rewards
   */
  cheat_match2Reset2DailyChallenge: action((state, args: void, api) => {
    Match2.dailyChallengeModifiers.clearDailyChallenge(state);
    Match2.dailyChallengeModifiers.startDailyChallenge(state, api.date.now());
  }),

  /**
   * Complete current daily challenge
   */
  cheat_match2ProgressDailyChallenge: action(
    (state, args: { ratio: number }, api) => {
      if (!state.match2.dailyChallenge) return;
      const config =
        Match2.dailyChallengeGetters.getDailyChallengeConfig(state);
      if (!config) return;
      state.match2.dailyChallenge.progress += Math.round(
        config.requirement * args.ratio,
      );
    },
  ),
});
